import { useContext } from "react";
import {
  HistoryContext,
  HistoryContextType,
} from "../context/HistoryContextProvider";

export const useHistoryContext = (): HistoryContextType => {
  const context = useContext(HistoryContext);
  if (context === undefined) {
    throw new Error("useHistoryContext must be used within a HistoryProvider");
  }
  return context;
};
